import { RefObject, useEffect, useState } from 'react';

/**
 * Height an element takes up after `transform: scale(scale)`.
 *
 * A CSS transform doesn't change an element's layout size, so a scaled-down
 * document still reserves its full unscaled height and its scroll container
 * keeps scrolling past the end. Give a wrapper this height (with overflow
 * hidden) to make the scrollable area match what's visible.
 */
export function useScaledHeight(
  ref: RefObject<HTMLElement>,
  scale: number,
): number | undefined {
  const [height, setHeight] = useState<number>();

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    // offsetHeight is the untransformed layout height
    const observer = new ResizeObserver(() => setHeight(el.offsetHeight));
    observer.observe(el);
    return () => observer.disconnect();
  }, [ref]);

  return height ? height * scale : undefined;
}
